import { render, staticRenderFns } from "./UsuarioDetalhe.vue?vue&type=template&id=669759d7"
import script from "./UsuarioDetalhe.vue?vue&type=script&lang=js"
export * from "./UsuarioDetalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports